import axios from "axios";
import makeRequest from "@/api/makeRequest";

axios.interceptors.request.use(function (config) {
  const data = localStorage.getItem("token");
  if (data && config.headers) {
    config.headers.token = JSON.parse(data);
  }

  return config;
});

const ReportsApi = {
  checkReadiness: async (examId: number): Promise<boolean> => {
    const { data } = await makeRequest<boolean>({
      url: `/reports/${examId}/ready`,
    });
    return data;
  },
  getTestDataReport: async (
    examId: number
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axios.get(`/reports/test-data/${examId}`, {
      responseType: "blob",
      baseURL: process.env.REACT_APP_SERVER_URL,
    });
    const filenameMatch = response.headers["content-disposition"].match(
      /(?<=filename=")(.*)(?=.xlsx)/
    );
    const filename = filenameMatch ? filenameMatch[0] : "Test Report";
    const blob = response.data;

    return {
      filename,
      blob,
    };
  },
  getTestReport: async (
    examId: number
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await axios.get(`/reports/test-report/${examId}`, {
      responseType: "blob",
      baseURL: process.env.REACT_APP_SERVER_URL,
    });
    const filenameMatch = response.headers["content-disposition"].match(
      /(?<=filename=")(.*)(?=.xlsx)/
    );
    const filename = filenameMatch ? filenameMatch[0] : "Test Report";
    const blob = response.data;

    return {
      filename,
      blob,
    };
  },
};

export default ReportsApi;
